import styled from 'styled-components';
import { STYLING } from 'helpers/config';

export const Comments = styled.div`
  margin-top: ${STYLING.spacing.l};
  padding-top: ${STYLING.spacing.m};
  border-top: 1px solid var(--color-gray3);
`;
